import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import { Container, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Logo from "../../components/Logo";
import LoginForm from "./LoginForm";
import { RootState } from "../../store";
import LanguagePopover from "../../layouts/dashboard/header/LanguagePopover";

const StyledRoot = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const StyledSection = styled("div")(({ theme }: any) => ({
  width: "100%",
  maxWidth: 480,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

export const LoginPage = () => {
  const { t } = useTranslation();
  const mdUp = useResponsive("up", "md");
  const navigate = useNavigate();
  const appUser = useSelector((state: RootState) => state.appUser);

  useEffect(() => {
    if (appUser?.user?.id) {
      navigate("/dashboard", { replace: true });
    }
  }, [appUser]);

  return (
    <>
      <Helmet>
        <title>{`${t("Login")} | ${t("AppTitle")}`}</title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: "fixed",
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {/* {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              {t("HiWelcomeBack")}
            </Typography>
            <img
              src="/assets/illustrations/illustration_login.png"
              alt={t("Login").toString()}
            />
          </StyledSection>
        )} */}

        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              {t("HiWelcomeBack")}
            </Typography>

            <video
              autoPlay
              loop
              muted
              playsInline
              style={{ width: "100%", maxWidth: 600 }}
            >
              <source
                src="/assets/illustrations/illustration_login.mp4"
                type="video/mp4"
              />
              <img
                src="/assets/illustrations/illustration_login.png"
                alt={t("Login").toString()}
              />
              Your browser does not support the video tag.
            </video>
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            {/* <Typography variant="h5" gutterBottom>
              {t("Signinto")}
            </Typography> */}

            {/* {process.env.REACT_APP_ENV === "DEMO" ? (
              <Typography variant="body2" sx={{ mb: 5, color: "#ff5a00" }}>
                <div style={{ marginBottom: "5px" }}>
                  {t("UsethebelowCredientialstologin")}
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>{t("UserName")}: </span>
                  <span>user</span>
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>{t("Password")}: </span>
                  <span>user@123</span>
                </div>
              </Typography>
            ) : (
              <Typography variant="body2" sx={{ mb: 5 }}>
                {t("Donthaveanaccount")} {""}
                <Link
                  variant="subtitle2"
                  sx={{ cursor: "pointer" }}
                  onClick={() => navigate("/register")}
                >
                  {t("Getstarted")}
                </Link>
              </Typography>
            )} */}

            {/* <Stack direction="row" spacing={2}>
              <Button fullWidth size="small" color="inherit" variant="outlined">
                <Iconify
                  icon="eva:google-fill"
                  color="#DF3E30"
                  width={22}
                  height={22}
                />
              </Button>

              <Button fullWidth size="small" color="inherit" variant="outlined">
                <Iconify
                  icon="eva:facebook-fill"
                  color="#1877F2"
                  width={22}
                  height={22}
                />
              </Button>

              <Button fullWidth size="small" color="inherit" variant="outlined">
                <Iconify
                  icon="eva:twitter-fill"
                  color="#1C9CEA"
                  width={22}
                  height={22}
                />
              </Button>
            </Stack>

            <Divider sx={{ my: 3 }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {t("OR")}
              </Typography>
            </Divider> */}

            <LoginForm />
          </StyledContent>
        </Container>
      </StyledRoot>

      <span style={{ position: "fixed", top: "10px", right: "10px" }}>
        <LanguagePopover />
      </span>
    </>
  );
};
